import { withRouter } from "react-router-dom";
import { connect, useSelector, useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import CipHeader from "../Components/CipHeader";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Modal } from "react-responsive-modal";
import medpassService from "../services/emar-medpass-service";
import cogoToast from "cogo-toast";
import Loader from "react-loader-spinner";
import { selectUsers } from "../state/reducers/userSlice";
import { updateSelectedPatient, clearSelectedPatient, updateFilters, clearFilters, selectPatient } from "../state/reducers/emarSlice";
import NO_PATIENTS from "../assets/img/no-patients.png";
import PAUSE from "../assets/img/pause.svg";
import React, { useState, useEffect , createRef, useRef} from "react";
import moment from "moment";
import { Multiselect } from "multiselect-react-dropdown";
import Select from 'react-dropdown-select';
import facilityService from "../services/facility-service";
import emarMedpassService from "../services/emar-medpass-service";

const MedpassAdministration = ({ history }) => {
  const { user } = useSelector(selectUsers);
  const { filters } = useSelector(selectPatient);
  const dispatchEmar = useDispatch();
  const [reason, setReason] = useState("");
  const [modalReason, setModalReason] = useState("");
  const [holdReasonList, setHoldReasonList] = useState([]);
  const [reasonList, setReasonList] = useState([]);
  const [medReasonList, setMedReasonList] = useState([]);
  const [completed, setCompleted] = useState(filters?.isCompleted || false);
  const [loading, setLoading] = useState(false);
  const [date, setDate] = useState(filters?.dateSelected ? new Date(filters?.dateSelected) : new Date());
  const [time, setTime] = useState(filters?.rangeSelected || "");
  const [passes, setPasses] = useState([]);
  const [types, setTypes] = useState([]);
  const [type, setType] = useState(filters?.typeSelected || "");
  const [region, setRegion] = useState(filters?.locationSelected || "");
  const [openMedicationPopup, setOpenMedicationPopup] = useState(false);
  const [disableModalReason, setDisableModalReason] = useState(false);
  const [disableModalMedications, setDisableModalMedications] = useState(false);
  const [defaultRejectedReason, setDefaultRejectedReason] = useState("");
  const [selectedTime, setSelectedTime] = useState(filters?.rangeSelected || []);
  const [selectedTimeText, setSelectedTimeText] = useState([]);
  const onCloseMedicationModal = async () => {
    setOpenMedicationPopup(false);
    setPatData({});
    setMedications([]);
    setActiveOrders([]);
    setActiveStatMeds([]);
    setIsDiabetic(false);
    setIsHypersensitive(false);
    setSystolic();
    setDiastolic();
    setHeartRate();
    setBloodSugar();
    setUnitsInj();
    setDisableModalMedications(false);
    setDisableModalReason(false);
    document.getElementById("patSearch").focus();
  };
  const [patients, setPatients] = useState([]);
  const [totalPatients, setTotalPatients] = useState([]);
  const [patData, setPatData] = useState({});
  const [regionsList, setRegionsList] = useState([]);
  const [medications, setMedications] = useState([]);
  const [vitals, setVitals] = useState({});
  const [isDiabetic, setIsDiabetic] = useState(false);
  const [isHypersensitive, setIsHypersensitive] = useState(false);
  const [systolic, setSystolic] = useState();
  const [diastolic, setDiastolic] = useState();
  const [heartRate, setHeartRate] = useState();
  const [bloodSugar, setBloodSugar] = useState();
  const [unitsInj, setUnitsInj] = useState();
  const [endPassStatus, setEndPassStatus] = useState(true);
  const [search, setSearch] = useState("");
  const [rxcode, setRxcode] = useState("");
  const [startRange, setStartRange] = useState('');
  const [endRange, setEndRange] = useState('');
  const [drgName, setDrugName] = useState([]);
  const [drgList, setDrugList] = useState([]);
  const [totalDrgList, setTotalDrugList] = useState([]);
  const multiselectRefDrug = createRef();
  const kopInputRef = useRef(null);
  const [KOPInputValues, setKOPInputValues] = useState({});
  const handleSearch = async (val) => {
    setDrugList([]);
    let fList = [...totalDrgList]
    let filteredList = fList.filter((item) => item.drg_name.toUpperCase().startsWith(val.toUpperCase()));
    setDrugList([...filteredList]);
  };
  const getDrugList = async (fac_id) => {
      try {
        let response = await emarMedpassService.getDrugs(fac_id);
        response.sort((a, b) => {
          const nameA = a.drg_name.toUpperCase(); // ignore upper and lowercase
          const nameB = b.drg_name.toUpperCase(); // ignore upper and lowercase
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
        
          // names must be equal
          return 0;
        });
        setDrugList([]);
        setDrugList(response);
        setTotalDrugList([]);
        setTotalDrugList(response); 
      } catch (e) {
        const { hide } = cogoToast.error(
          "Error retrieving drugs. Please contact administrator.",
          {
            hideAfter: 15,
            onClick: () => {
              hide();
            },
          }
        );
      }
  };

  const handleAdministerAll = async (e) => {
    medications.forEach(item =>{
      if(item?.status !== 'P' && item?.status !== 'D' && item?.is_kop !== 'T'){
        item.status = user?.userRole === "EMAR_USER" ? 'S' : 'A';
      }
    });
    setMedications([...medications]);
    setDisableModalReason(true);
    setModalReason("");
  }
  const handleScanRX = async (e) => {
    if (e.key === "Enter" && rxcode !== "") {
      const rowIndex = medications?.find(item => item?.rx_number === Number(rxcode));
      if(rowIndex?.is_kop !== 'T'){
        rowIndex.status = user?.userRole === "EMAR_USER" ? 'S' : 'A';
        setMedications([...medications]);
        setDisableModalReason(true);
        setModalReason("");
        setRxcode("");
      }
    }

  }
  const handleMedication = async (rowData, index, action, element) => {
    element.scrollIntoView();
    if (!disableModalMedications) {
      const row = medications[index];
      row.status = action;
      if (action !== "N") {
        medications[index].med_reason_id = 0;
      }
      setMedications([...medications]);
      setDisableModalReason(true);
      setModalReason("");
    }
  };

  const handleActiveOrders = async (rowData, index, action, element) => {
    element.scrollIntoView();
      const row = activeOrders[index];
      row.status = action;
      setActiveOrders([...activeOrders]);
  };

  const handleMedicationReasonForActiveOrders = async (rowData, index, reason, key) => {
    const row = activeOrders[index];
    row[key] = reason;
    setActiveOrders([...activeOrders]);
  };
  const handleMedicationReason = async (rowData, index, reason, key) => {
    const row = medications[index];
    row[key] = reason;
    setMedications([...medications]);
  };
  const [access, setAccess] = useState({});
  useEffect(() => {
    getAccessForFacility(user?.facility);
    getDrugList(user?.facility);
  }, [user?.facility]);
  useEffect(() => {
    var filterText = [];
    if (filters?.rangeSelected && passes?.length > 0) {
      filters?.rangeSelected?.forEach(item => {
        var num = passes?.find(ele => Number(ele.id) === Number(item));
        filterText.push(num?.title);
      });
      setSelectedTimeText(filterText);
    }
  }, [filters, passes]);
  const getAccessForFacility = async (id) => {
    try {
      let resp = await facilityService.getAccessForFacilities(id);
      setAccess(resp);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error getting data. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };
  const [activeOrders, setActiveOrders] = useState([]);
  const getPatientActiveOrders = async (patId) => {
    try {
      let passes = [];
      selectedTime?.forEach(ele => passes.push(Number(ele)));
      let resp = await emarMedpassService.getEmarActiveOrders( moment(date).format("MM/DD/YYYY"),  patId, passes);
      setActiveOrders(resp);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error getting data. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };
  const [activeStatMeds, setActiveStatMeds] = useState([]);
  const getPatientStatMeds = async (patId) => {
    try {
      let resp = await emarMedpassService.getEmarPatientMedStats( moment(date).format("MM/DD/YYYY"),patId, user?.facility );
      setActiveStatMeds(resp);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error getting data. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };
  const [limit, setLimit] = useState(50);
  const [nextUrl, setNextUrl] = useState('');
  function debounce(func, wait) {
    let timeout;
    return function() {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        func.apply(this, arguments);
      }, wait);
    };
  }
  const [isAtBottom, setIsAtBottom] = useState(false);
  const handleMedScroll = () => {
    if(window.scrollY +window.innerHeight >= document.body.scrollHeight){
          setIsAtBottom(true);
    }else{
      setIsAtBottom(false);
    }
  };
  useEffect(() => {
    window.addEventListener('scroll', debounce(handleMedScroll,1000));
    return () => window.removeEventListener('scroll', handleMedScroll);
  }, [loading]);
  useEffect(() => {
    if (isAtBottom &&  nextUrl) {
      getPatients(nextUrl, true);
    }
  }, [isAtBottom]);

  const formQuery = (date, region, type, search,completed,limit) => {
    var query = "";
    if (date) {
      query += "date=" + moment(date).format("MM/DD/YYYY")
    }
    if (region) {
      query += "&block=" + region
    }
    if (type) {
      query += "&filter=" + type
    }
    if (search) {
      query += "&search=" + search?.replace(/^0+/, '')
    }
    query += "&isComplete=" + completed
    query += "&limit=" + limit ;
    return query;
  }
  const getPatients = async (query, append) => {
    try {
      if (selectedTime?.length) {
        setLoading(true);
        let passes = [];
        selectedTime?.forEach(ele => passes.push(Number(ele)));
        const resp = await medpassService.getEmarPatients(
          query,
          passes
        );
        if(!nextUrl){
          document.getElementById("patSearch").focus();
        }
        setNextUrl(resp?.nextUrl?.split('?')[1])
        if (append) {
          let total = [...totalPatients, ...resp?.response]
          setPatients(total);
          setTotalPatients(total);
        } else {
          setPatients([...resp?.response]);
          setTotalPatients([...resp?.response]);
        }
        if (search && resp?.response?.length === 1 && !completed) {
          setPatData(resp?.response?.[0]);
          getMedications(resp?.response?.[0].pat_id);
        }
        setLoading(false);
        let defaultReason = reasonList?.find(
          (item) => item.is_default === "T"
        );
        setReason(defaultReason?.id);
        dispatchEmar(clearFilters());
      } else {
        setPatients([]);
        setTotalPatients([]);
      }    
      setIsAtBottom(false);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error getting patients. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };
  const handleEndMedpass = async () => {
    try {
      await medpassService.submitEndMedpass({
        med_date: date,
        range_id: selectedTime?.[0],
        reason_id: reason,
        status: "T",
      });
      const { hide } = cogoToast.success("Request submitted successfully.", {
        hideAfter: 15,
        onClick: () => {
          hide();
        },
      });
      setTime("");
      setSelectedTime([]);
      setSelectedTimeText([]);
      setPatients([]);
      setTotalPatients([]);
      setEndMedpassOpen(false);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error submitting medpass. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };

  const getMedications = async (patId) => {
    try {
      let passes = [];
      selectedTime?.forEach(ele => passes.push(Number(ele)));
      const resp = await medpassService.getPatientMedications(
        moment(date).format("MM/DD/YYYY"),
        patId,
        passes
      );
      const diabetic = resp?.patientMedicationViewModels?.findIndex((item) => item?.is_diabetic === "T");
      if (diabetic !== -1) {
        setIsDiabetic(true);
        setBloodSugar(resp?.vitalModel?.blood_sugar);
        setUnitsInj(resp?.vitalModel?.units_inj);
      }
      const is_hypertensive = resp?.patientMedicationViewModels?.findIndex(
        (item) => item?.is_hypertensive === "T"
      );
      if (is_hypertensive !== -1) {
        setIsHypersensitive(true);
        setDiastolic(resp?.vitalModel?.diastolic);
        setSystolic(resp?.vitalModel?.systolic);
        setHeartRate(resp?.vitalModel?.heart_rate);
      }
      setVitals(resp?.vitalModel);
      setMedications(resp?.patientMedicationViewModels);
      setInitialKOPInputValues(resp?.patientMedicationViewModels);
      setModalReason(resp?.patientMedicationViewModels?.[0]?.reason_id);
      const disableDropdown = resp?.patientMedicationViewModels?.findIndex(item => item.status !== "");
      if (disableDropdown !== -1) {
        setDisableModalReason(true);
      }
      getPatientActiveOrders(patId);
      getPatientStatMeds(patId);
      setOpenMedicationPopup(true);
      setTimeout(() =>{
        document.getElementById("rxCode").focus();
      },500);
      
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error getting patient medication. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };


  const setInitialKOPInputValues = (allMedications) => {
    const initialValues = {};
    allMedications.forEach(item => {
      if (item.is_kop === "T") {
        const doseTaken = item.status === 'K' ? item.dose_taken_qty : item.qty_dsp
        initialValues[item.rxf_id] = String(doseTaken);
      }
    });
    setKOPInputValues(initialValues);
  }
  const doKOPQtyValidation = async (fil_id, qty, i) => {
    if(!fil_id || qty === "null"){
      return
    }
    try {
      const resp = await medpassService.postKOPQtyValidation(
        fil_id,
        qty);
        if(!resp?.isValid){
          const updatedMedications = medications;
          updatedMedications[i].koperror = true;
          setMedications([]);
          setMedications([...updatedMedications]);
        }else {
          const updatedMedications = medications;
          updatedMedications[i].days_supply = resp?.days_given;
          updatedMedications[i].kop_range_ids = resp?.range_ids;
          updatedMedications[i].koperror = false;
          setMedications([]);
          setMedications([...updatedMedications]);
        }
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error validating kop quantity. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };
  const handleInputChange = (e, i, id) => {
    let obj = KOPInputValues;
    obj[id] = Number( e.target.value)
    setKOPInputValues(obj)
    const updatedMedications = medications;
    updatedMedications[i].dose_taken_qty = Number(e.target.value);
    setMedications([]);
    setMedications([...updatedMedications]);
    if( Number( e.target.value) >= 0) {
      doKOPQtyValidation( updatedMedications[i].fil_id, Number(e.target.value), i);
    }
  }

 useEffect(() => {
    const getData = setTimeout(() => {
      let query = formQuery(date, region, type, search, completed,limit);
      if(!completed){
        getPatients(query, false);
      }
    }, 500)
    return () => clearTimeout(getData)
  }, [search]);


  const handleMedicationSubmit = async () => {
    try {
      setLoading(true);
      if( document.getElementsByClassName('error').length > 0){
        const { hide } = cogoToast.error(
          "There are one or more errors. Please fix the errors before submitting.",
          {
            hideAfter: 15,
            onClick: () => {
              hide();
            },
          }
        );
        setLoading(false);
        return
      }
      let kopqtyerror = false;
      medications.forEach((item,i ) => {
       if(item?.kop_date !== ''&& item.dose_taken_qty === 'null' && item.is_kop === 'T'){
        const { hide } = cogoToast.error(
          "Please provide quantity",
          {
            hideAfter: 15,
            onClick: () => {
              hide();
            },
          }
        );
        kopqtyerror = true;
       } 
      })
      if(kopqtyerror){
        setLoading(false);
          return;
      }
      var vModel = vitals;
      if (isHypersensitive) {
        vModel.systolic = systolic;
        vModel.diastolic = diastolic;
        vModel.heart_rate = heartRate;
      }
      if (isDiabetic) {
        vModel.blood_sugar = bloodSugar;
        vModel.units_inj = unitsInj;
      }
      let medicationsList = medications?.map(item => {
        item['reason_id'] = modalReason || null;
        if((item?.status === 'A' || item?.status === 'S' )  && Number(item.dose_taken_qty) === 0){
          item['dose_taken_qty'] = item.dose_qty;
        }
        if(item?.status === 'N' && Number(item.med_reason_id) === 0){
          item['med_reason_id'] = defaultRejectedReason;
        }
        return item;
      });

      await medpassService.submitMedication({ 'vitalModel': vModel, 'medPassAdminModels': medicationsList });
      handleActiveOrdersSubmit();
      setOpenMedicationPopup(false);
      setPatData({});
      setMedications([]);
      if(search?.length === 0){
        let query = formQuery(date, region, type, search, completed,limit);
        getPatients(query, false);
      }
      setSearch("");
      onCloseMedicationModal();
      const { hide } = cogoToast.success("Request submitted successfully.", {
        hideAfter: 15,
        onClick: () => {
          hide();
        },
      });
      setLoading(false);
    } catch (e) {
      setLoading(false);
      const { hide } = cogoToast.error(
        "Error submitting data. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };
  const getDefaultSettings = async () => {
    try {
      const resp = await medpassService.getDefaults(user?.facility);
      dispatchEmar(clearSelectedPatient());
      setTypes(resp?.filters);
      setPasses(resp?.ranges);
      setType("All");
      setRegionsList(resp?.blocks);
      setReasonList(resp?.common_reasons);
      setMedReasonList(resp?.rejected_reasons);
      setHoldReasonList(resp?.hold_reasons);
      var defaultReason = resp?.common_reasons?.find(
        (item) => item.is_default === "T"
      );
      setReason(defaultReason?.id);
      let defaultRejected = resp?.rejected_reasons?.find(
        (item) => item.is_default === "T"
      );
      setDefaultRejectedReason(defaultRejected?.id);
      // setModalReason(defaultReason?.id);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error getting data. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };

  const getEndPassStatus = async () => {
    try {
      if (date && time) {
        const resp = await medpassService.getEndPass(moment(date).format("MM/DD/YYYY"), time);
        setEndPassStatus(resp?.status === 'T' ? false : true);
      }
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error getting data. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };
  const handleStatMedsSubmit = async () => {
    try {
      if (Number(amount) === 0 || amount === '' || drgName?.length === 0) {
        setError(true);
        return;
      }

      const params = {
        "range_id": selectedTime?.[0],
        "med_date": moment(date).format("MM/DD/YYYY"),
        "pat_id": patData?.pat_id,
        "drg_id": drgName[0].drg_id,
        "status": 'P',
        "dose_taken_qty": amount
      }
      await medpassService.submitMedication({"medPassAdminModels": [params]});
      const { hide } = cogoToast.success("Request submitted successfully.", {
        hideAfter: 15,
        onClick: () => {
          hide();
        },
      });
      getMedications(patData?.pat_id);
      onStatMedpassCloseModal();
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error getting data. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };
  const handleActiveOrdersSubmit = async () => {
    try {
      var models = [];
      for (var i = 0; i < activeOrders.length; i++) {
          let params = {
            "range_id": selectedTime?.[0],
            "med_date": moment(date).format("MM/DD/YYYY"),
            "pat_id": patData?.pat_id,
            "drg_id": activeOrders[i]?.drg_id,
            "rx_number": activeOrders[i]?.rx_number,
            "rxf_id": activeOrders[i]?.rxf_id,
            "status": activeOrders[i]?.status,
            "dose_taken_qty":activeOrders[i]?.dose_taken_qty || activeOrders[i]?.dose_qty
          }
          models.push(params);
      }
      await medpassService.submitMedication({"medPassAdminModels": models});
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error getting data. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };
  const handleHold = async () => {
    try {
      if (endDate === "" || startDate === "" || holdReason === "" || startRange === '' || endRange === '' ) {
        setError(true);
        return;
      }
      var params = {
        "pat_id": patArguments.pat_id,
        "range_id": selectedTime[0],
        "start_date": moment(startDate).format("MM/DD/YYYY"),
        "end_date":  moment(endDate).format("MM/DD/YYYY"),
        "reason_id": holdReason,
        "start_date_range_id": startRange,
        "end_date_range_id": endRange,
        "is_hold": 'T',
        "fac_id": user?.facility,
        "id": patArguments.status_id
      };

      await medpassService.postOnHold(params);
      onCloseOnHoldModal();
      let query = formQuery(date, region, type, search,completed,limit);
      getPatients(query, false);

    } catch (e) {
      const { hide } = cogoToast.error(
        "Error submitting data. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };
  useEffect(() => {
    let query = formQuery(date, region, type, search, completed,limit);
    getPatients(query, false);
    getDefaultSettings();
    // getEndPassStatus();
  }, [user?.facility]);
  useEffect(() => {
    if (passes) {
      const currentDate = new Date();
      const timestamp = currentDate.getTime();
      for (let i = 0; i < passes.length; i++) {
        let start = new Date(passes[i].start_time).getTime();
        let close = new Date(passes[i].close_time).getTime();
        if (timestamp > start && timestamp < close) {
          setTime(passes?.[i]?.id);
          setSelectedTime([passes?.[i]?.id]);
        }
      }
    }
  }, [passes]);
  const handleNavigationToHistory = async (item) => {
    try {
      dispatchEmar(updateSelectedPatient(item));
      await history.push("/medhistory");
      dispatchEmar(updateFilters({ 'dateSelected': date, 'rangeSelected': selectedTime, 'locationSelected': region, 'typeSelected': type, 'isCompleted': completed }))
    } catch (e) {
      setLoading(false);
    }
  };

  useEffect(() => {
    let query = formQuery(date, region, type, search, completed,limit);
    getPatients(query, false);
    // getEndPassStatus();
  }, [selectedTime, date, region, type, completed]);
  const [endMedpassOpen, setEndMedpassOpen] = useState(false);
  const onEndMedpassOpenModal = () => {
    setEndMedpassOpen(false);
  };
  const [amount, setAmount] = useState('');
  const [statMedpassOpen, setStatMedpassOpen] = useState(false);
  const onStatMedpassCloseModal = () => {
    setStatMedpassOpen(false);
    setError(false);
    setAmount('');
    setDrugName([]);
  };
  const [openOnHoldPopUp, setOnHoldOpenPopUp] = useState(false);
  const [patArguments, setPatArguments] = useState({});
  const onCloseOnHoldModal = () => {
    setOnHoldOpenPopUp(false);
    setPatArguments({});
    setStartDate("");
    setEndDate("");
    setHoldReason("");
    setError(false);
    setStartRange('');
    setEndRange('');
  };
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [holdReason, setHoldReason] = useState("");
  const [error, setError] = useState(false);
  useEffect(() => {
    if (Object.keys(patArguments)?.length) {
      setStartDate(patArguments.start_date ? new Date(moment.utc(patArguments.start_date).format('MM/DD/YYYY')) : new Date());
      setEndDate(patArguments.end_date ? new Date(moment.utc(patArguments.end_date).format('MM/DD/YYYY')) : new Date());
      setHoldReason(patArguments?.hold_reason_id || "");
      setStartRange(patArguments?.start_range_id || '');
      setEndRange(patArguments?.end_range_id || '');
    }
  }, [patArguments]);

  const handleDeleteMedsGivenToday = async (id, patId) => {
    try {
      setLoading(true);
      await emarMedpassService.deleteMedsGivenToday(id);
      const { hide } = cogoToast.success("Stat Med deleted successfully.", {
        hideAfter: 15,
        onClick: () => {
          hide();
        },
      });
      let patientMedStatsResp = await emarMedpassService.getEmarPatientMedStats( moment(date).format("MM/DD/YYYY"),patId, user?.facility );
      setActiveStatMeds(patientMedStatsResp);
      let passes = [];
      selectedTime?.forEach(ele => passes.push(Number(ele)));
      let activeOrdersResponse = await emarMedpassService.getEmarActiveOrders( moment(date).format("MM/DD/YYYY"),  patId, passes);
      setActiveOrders(activeOrdersResponse);
      setLoading(false);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error deleting Stat Medication. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
  };

  return (
    <>
      <CipHeader />
      <Modal open={endMedpassOpen} onClose={onEndMedpassOpenModal} center>
        <div className="pt-10 px-8 pb-4 ">
          <h3
            className="text-lg leading-6 font-medium text-gray-900 text-center"
            id="modal-headline"
          >
            There are {totalPatients.filter(item => item?.is_medpass_completed !== 'T')?.length} patients who are pending for medpass administration. Are you sure you want to end medpass?
          </h3>
          <div className="flex justify-center">
            <button
              onClick={() => {
                handleEndMedpass();
              }}
              type="button"
              className="mr-4 rounded font-medium h-10 text-white w-auto px-6 bg-secondary bg-login_btn mb-3 mt-4 focus:outline-none"
            >
              Yes
            </button>
            <button
              onClick={() => {
                setEndMedpassOpen(false);
              }}
              type="button"
              className="rounded font-medium h-10 text-white w-auto px-4 bg-grey bg-login_btn mb-3 mt-4 focus:outline-none"
            >
              Cancel
            </button>
          </div>
          {/*
           */}
        </div>
      </Modal>
      <Modal open={openOnHoldPopUp} onClose={onCloseOnHoldModal} center >
        <div className="pt-6 px-8 pb-12 ">
          <h3
            className="text-2xl leading-6 font-medium  font-bold "
            id="medication-headline"
          >
            ON HOLD
          </h3>
          <div className="bg-white mt-4 rounded ">
            <div className="p-2 text-xs">
              <ul className="hold">

                <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-6">
                  <label className="text-labelclr font-semibold text-sm tracking-wider">
                    Select Reason
                  </label>
                  <span className="text-xs md:text-sm text-hlred ml-1">
                    *
                  </span>
                  <select
                    name="reason"
                    aria-label="Select Reason"
                    onChange={(e) =>
                      setHoldReason(e.target.value)
                    }
                    value={holdReason}
                    className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm"
                  >
                    <option value="">Select Reason</option>
                    {holdReasonList
                      ? holdReasonList.map((item, i) => {
                        return (
                          <option
                            key={item.id}
                            value={item.id}
                          >
                            {item.reason}
                          </option>
                        );
                      })
                      : null}
                  </select>
                  {error && holdReason?.length === 0 && (
                    <p className="text-xs md:text-sm md:pt-1 text-hlred">
                      You must specify reason
                    </p>
                  )}
                </li>

                <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-6">
                  <label className="text-labelclr font-semibold text-sm tracking-wider">
                    Start Date
                  </label>
                  <span className="text-xs md:text-sm text-hlred ml-1  mr-8">
                    *
                  </span>
                  <DatePicker
                    placeholderText="MM/DD/YYYY"
                    selected={startDate}
                    minDate={moment().toDate()}
                    excludeDates={[moment(), moment().subtract(1, "days")]}
                    onChange={(dob) => {
                      setStartDate(dob);
                    }}
                    className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-full  text-fogotpwsd_login text-sm"
                  />
                  {error && startDate === "" && (
                    <p className="text-xs md:text-sm md:pt-1 text-hlred table">
                      You must specify start date
                    </p>
                  )}
                </li>
                <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-6">
                  <label className="text-labelclr font-semibold text-sm tracking-wider">
                    Select Start Range
                  </label>
                  <span className="text-xs md:text-sm text-hlred ml-1">
                    *
                  </span>
                  <select
                    name="range"
                    aria-label="Select Start Range"
                    value={startRange}
                    onChange={(e) => setStartRange(e.target.value)}
                    className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm"
                  >
                    <option value="">Select Start Range</option>
                    {passes
                      ? passes.map((pass, i) => {
                        return (
                          <option key={pass.id} value={pass.id}>
                            {pass.title}
                          </option>
                        );
                      })
                      : null}
                  </select>
                  {error && startRange?.length === 0 && (
                    <p className="text-xs md:text-sm md:pt-1 text-hlred">
                      You need to specify start range
                    </p>
                  )}
                </li>
                <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-6">
                  <label className="text-labelclr font-semibold text-sm tracking-wider">
                    End Date
                  </label>
                  <span className="text-xs md:text-sm text-hlred ml-1  mr-8">
                    *
                  </span>
                  <DatePicker
                    placeholderText="MM/DD/YYYY"
                    selected={endDate}
                    minDate={moment(patArguments.end_date).isAfter(new Date())  ?  moment(new Date(), "MM/DD/YYYY").subtract(1, "days").toDate() : moment().toDate()}
                    onChange={(dob) => {
                      setEndDate(dob);
                    }}
                    className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-full  text-fogotpwsd_login text-sm"
                  />
                  {error && endDate === "" && (
                    <p className="text-xs md:text-sm md:pt-1 text-hlred table">
                      You must specify end date
                    </p>
                  )}
                </li>
                <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-6">
                  <label className="text-labelclr font-semibold text-sm tracking-wider">
                    Select End Range
                  </label>
                  <span className="text-xs md:text-sm text-hlred ml-1">
                    *
                  </span>
                  <select
                    name="range"
                    aria-label="Select End Range"
                    value={endRange}
                    onChange={(e) => setEndRange(e.target.value)}
                    className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm"
                  >
                    <option value="">Select End Range</option>
                    {passes
                      ? passes.map((pass, i) => {
                        return (
                          <option key={pass.id} value={pass.id}>
                            {pass.title}
                          </option>
                        );
                      })
                      : null}
                  </select>
                  {error && endRange?.length === 0 && (
                    <p className="text-xs md:text-sm md:pt-1 text-hlred">
                      You need to specify end range
                    </p>
                  )}
                </li>
              </ul>
            </div>
          </div>

          <div className="flex justify-center mt-3">
            <button
              onClick={() => {
                onCloseOnHoldModal();
              }}
              type="button"
              className="mr-3 rounded font-medium h-10 text-white w-auto px-4 bg-grey bg-login_btn mb-3 mt-4 focus:outline-none"
            >
              Cancel
            </button>
            <button
              onClick={() => {
                handleHold();
              }}
              type="button"
              className=" rounded font-medium h-10 text-white w-auto px-6 bg-secondary bg-login_btn mb-3 mt-4 focus:outline-none"
            >
              Submit
            </button>


          </div>
        </div>
      </Modal>

      <Modal open={statMedpassOpen} onClose={onStatMedpassCloseModal} center styles={{ modal: { height: "400px", "overflowY": "visible" , "width": "650px"} }}>
        <div className="pt-6 px-8 pb-12 ">
          <h3
            className="text-2xl leading-6 font-medium  font-bold "
            id="medication-headline"
          >
            STAT MEDS
          </h3>
          <div className="bg-white mt-4 rounded ">
            <div className="p-2 text-xs">
              <ul>

                <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-6">
                  <label className="text-labelclr font-semibold text-sm tracking-wider">
                    Drug name
                  </label>
                  <span className="text-xs md:text-sm text-hlred ml-1">
                    *
                  </span>
                 
                  {drgList ? (
                    <Select
                      name="drgList"
                      options={drgList}
                      labelField="drg_name"
                      values={drgName}
                      valueField="id"
                      multi={false}
                      searchable={true}
                      onChange={(selectedList) => {
                        setDrugName(selectedList);
                      }}
                      onClearAll={() => {
                        setDrugName([]);
                      }}
                      searchFn={(val) => {
                        if (val.state.search){
                          return drgList.filter((item) => {
                            return item.drg_name.toUpperCase().startsWith(val.state.search.toUpperCase())
                        })
                        }else{
                          return drgList
                        }
                      }}
                    />
                  ) : (
                    ""
                  )}

                  {error && drgName?.length === 0 && (
                    <p className="text-xs md:text-sm md:pt-1 text-hlred">
                      You need to specify drug name
                    </p>
                  )}
                </li>
                {drgName?.length !== 0 && <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-6">
                  <label className="text-labelclr font-semibold text-sm tracking-wider">
                    Quantity
                  </label>
                  <span className="text-xs md:text-sm text-hlred ml-1">
                    *
                  </span>
                  <input
                    id="amount"
                    name="amount"
                    type="number"
                    value={amount}
                    placeholder="Enter"
                    onChange={(e) => {
                      setAmount(e.target.value)
                    }
                    }
                    className={` border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm`}
                  />
                  {error &&( Number(amount) === 0  || amount === '')&& (
                    <p className="text-xs md:text-sm md:pt-1 text-hlred">
                      You need to specify the quantity administered
                    </p>
                  )}
                </li>}
              </ul>
            </div>
          </div>

          <div className="flex justify-center mt-3">
            <button
              onClick={() => {
                onStatMedpassCloseModal();
              }}
              type="button"
              className="mr-3 rounded font-medium h-10 text-white w-auto px-4 bg-grey bg-login_btn mb-3 mt-4 focus:outline-none"
            >
              Cancel
            </button>
            <button
              onClick={() => {
                handleStatMedsSubmit();
              }}
              type="button"
              className=" rounded font-medium h-10 text-white w-auto px-6 bg-secondary bg-login_btn mb-3 mt-4 focus:outline-none"
            >
              Submit
            </button>


          </div>
        </div>
      </Modal>

      <Modal
        styles={{
          modal: { maxWidth: "90%", width: "90%", minWidth: "800px", overflowX: "hidden" },
        }}
        open={openMedicationPopup}
        onClose={onCloseMedicationModal}
      >
        <div className="pt-4 px-4 pb-4 ">
          <div className="flex flex-row w-full">
            <div className="">
              <img
                className="rounded-full w-28 h-28"
                alt=""
                src={patData?.profile_pic}
              />
            </div>
            <div className="w-4/5 ml-3 ">
              <div className="inline-flex">
                <div className="flex">
                  <h3
                    className="text-2xl leading-6 font-medium  font-bold "
                    id="medication-headline"
                  >
                    Administer Medication
                  </h3>
                </div>
                <div className="pl-3">
                {medications?.[0]?.allergies && <div className="text-base font-semibold text-balance w-full bg-lightBlue p-2 rounded">Allergies : {medications?.[0]?.allergies}</div>}
                </div>
              </div>
              
              <div className="flex flex-row">
                <div
                  className={`text-xl flex flex-column pt-4 font-semibold ${isHypersensitive ? "w-1/3" : isDiabetic ? "w-1/2" : "w-full"
                    } `}
                >
                  <div>
                    <div className="cursor-pointer underline" onClick={() => handleNavigationToHistory(patData)}>{patData?.pat_name}</div>
                    <span className="text-sm font-semibold">
                      {" "}
                      {patData?.pat_acct_nubmer}
                    </span>
                    <div className="text-xs font-semibold ">
                      <span>
                        {patData?.pat_gender} . {patData?.pat_age}
                      </span>
                      <div>
                        DOB: {moment.utc(patData?.pat_dob).format("MM/DD/YYYY")}
                      </div>
                    </div>
                  </div>
                 {patData?.is_dot === 'T' && <div className="dot-text">DOT</div>}
                </div>
                {(isDiabetic || (access?.vitals === 'T' && isHypersensitive)) && false && (
                  <div className=" w-2/3 mt-4 ml-4">
                    <div className="flex">
                      <span className={`text-base font-semibold w-full`}>
                        {" "}
                        Current vitals
                      </span>
                    </div>
                    <div className="flex flex-row">
                      {access?.vitals === 'T' && isHypersensitive && (
                        <span
                          className={` ${isDiabetic && isHypersensitive ? "w-1/5" : "w-1/3"
                            }`}
                        >
                          <div>
                            <label className="text-labelclr w-full font-semibold font-xxs tracking-wider">
                              What is the Patient's Heart Rate?
                            </label>
                          </div>
                          <input
                            id="hrate"
                            name="hrate"
                            type="number"
                            placeholde="Heart Rate"
                            value={heartRate}
                            onChange={(e) => setHeartRate(e.target.value === "" ?  "" :Math.abs(e.target.value))}
                            className={` ${false ? "border-red-400" : ""
                              } border focus:outline-none h-11 rounded-md pl-2  font-normal w-5/6 text-fogotpwsd_login text-sm`}
                          />
                        </span>
                      )}
                      {access?.vitals === 'T' && isHypersensitive && (
                        <span
                          className={` ${isDiabetic && isHypersensitive ? "w-1/5" : "w-1/3"
                            }`}
                        >
                          <div>
                            <label className="text-labelclr font-semibold font-xxs tracking-wider">
                              What is the Systolic ?
                            </label>
                          </div>
                          <input
                            id="systolic"
                            name="systolic"
                            type="number"
                            placeholder="Systolic"
                            value={systolic}
                            onChange={(e) => setSystolic(e.target.value === "" ?  "" :Math.abs(e.target.value))}
                            className={` ${false ? "border-red-400" : ""
                              } border focus:outline-none h-11 rounded-md pl-2 font-normal w-5/6 text-fogotpwsd_login text-sm`}
                          />
                        </span>
                      )}

                      {access?.vitals === 'T' && isHypersensitive && (
                        <span
                          className={` ${isDiabetic && isHypersensitive ? "w-1/5" : "w-1/3"
                            }`}
                        >
                          <div>
                            <label className="text-labelclr font-semibold font-xxs tracking-wider">
                              What is the Diastolic?
                            </label>
                          </div>
                          <input
                            id="diastolic"
                            name="diastolic"
                            type="number"
                            value={diastolic}
                            onChange={(e) => setDiastolic(e.target.value === "" ?  "" :Math.abs(e.target.value))}
                            placeholder="Diastolic"
                            className={` ${false ? "border-red-400" : ""
                              } border focus:outline-none h-11 rounded-md pl-2 font-normal w-5/6 text-fogotpwsd_login text-sm`}
                          />
                        </span>
                      )}
                      {isDiabetic && (
                        <span
                          className={` ${isDiabetic && isHypersensitive ? "w-1/5" : "w-1/2"
                            }`}
                        >
                          <div>
                            <label className="text-labelclr font-semibold font-xxs tracking-wider">
                              What is the Blood Sugar?
                            </label>
                          </div>
                          <input
                            id="bloodSugar"
                            name="bloodSugar"
                            type="number"
                            placeholder="Blood Sugar"
                            value={bloodSugar}
                            onChange={(e) => setBloodSugar(e.target.value === "" ?  "" :Math.abs(e.target.value))}
                            className={` ${false ? "border-red-400" : ""
                              } border focus:outline-none h-11 rounded-md pl-2 font-normal w-5/6 text-fogotpwsd_login text-sm`}
                          />
                        </span>
                      )}
                      {isDiabetic && (
                        <span
                          className={` ${isDiabetic && isHypersensitive ? "w-1/5" : "w-1/2"
                            }`}
                        >
                          <div>
                            <label className="text-labelclr font-semibold font-xxs tracking-wider">
                              How many units are you injecting?
                            </label>
                          </div>
                          <input
                            id="injecting"
                            name="injecting"
                            value={unitsInj}
                            onChange={(e) => setUnitsInj(e.target.value === "" ?  "" :Math.abs(e.target.value))}
                            type="number"
                            className={` ${false ? "border-red-400" : ""
                              } border focus:outline-none h-11 rounded-md pl-2 font-normal w-5/6 text-fogotpwsd_login text-sm`}
                          />
                        </span>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="pt-4 flex w-full flex-row">
            <div className="flex w-2/3">
            <input
              type="text"
              name="rxCode"
              id="rxCode"
              value={rxcode}
              autoFocus={true}
              placeholder="Scan RX"
              onChange={(e) => setRxcode(e.target.value)}
              onKeyDown={(e) => handleScanRX(e)}
              className="border focus:outline-none w-full focus:none h-10 rounded-md px-3 text-sm font-normal "
            />
            </div>
        
          { !( moment(date).isAfter(new Date())) &&   <div className="flex justify-end w-1/3">
          <button
                onClick={() => {
                  handleAdministerAll();
                }}
                type="button"
                className="mr-3 ml-3 rounded font-medium h-10 text-white w-auto px-6 bg-secondary bg-login_btn focus:outline-none"
              >
                Administer All
              </button>
              <button
                onClick={() => {
                  setStatMedpassOpen(true);
                }}
                type="button"
                className="mr-0.5 rounded font-medium h-10 text-white w-auto px-6 bg-secondary bg-login_btn focus:outline-none"
              >
                Stat Meds
              </button>
          </div>}
          </div>

          <div className="bg-white mt-3 rounded flex flex-row w-full">
            <div className="text-xs medicationSection bg-green-100  rounded-xl p-2 w-1/2 mr-2">
              <div className="flex w-full mb-4 bg-header_bg p-2 rounded-lg">
                <div className="w-1/2 font-semibold text-lg text-white">
                Current Medications
                </div>
                <div className="w-1/2 font-semibold text-lg text-white">
                  Administered
                  <span className="text-xs md:text-sm text-hlred ml-1">*</span>
                </div>
              </div>
              <ul className=" max-h-80  mt-4 overflow-y-auto  ">
                {(medications && medications?.length > 0 )
                  ? medications.map((item, i) => {
                    return (
                      <li key={Math.random()} className="focus:scroll-auto rounded-xl inline-block text-xs leading-6 text-menu_txt w-full mb-4 border-inherit rounded medicationList">
                        <div
                          className={`flex w-full rounded-xl ${(item?.status === "P"|| item?.status === "D") ? 'opacity-40 pointer-events-none' : ''} text-black px-3 pt-2  ${(item?.status === "A" || item?.status === "P")
                            ? "bg-mediApproved"
                            : item?.status === "S"
                              ? "bg-mediSelfApproved"
                            : item?.status === "N"
                              ? "bg-mediRejected"
                              : (item?.status === "R" || item?.status === "D")
                                ? "bg-mediRefused"
                                : disableModalMedications ? "bg-slate"
                                  : ""
                            }`}
                        >
                          <div className="w-1/2 flex-column">
                            <div className="text-base	font-semibold text-black">
                              {item.drg_name} {item?.is_diabetic === 'T' && <span className="bg-slate text-xs	ml-2">Insulin</span>}{item?.is_hypertensive === 'T' && <span className="bg-slate text-xs ml-2	">Blood Pressure</span>}
                              {item?.is_prn === 'T' && <span className="bg-slate text-xs ml-2	">PRN</span>}
                              {item?.is_crush === 'T' && <span className="bg-orange text-xs ml-2	">CRUSH</span>}
                              {item?.is_involuntary === 'T' && <span className="bg-orderFourhr text-xs ml-2	">INVOLUNTARY</span>}
                            </div>
                            {item?.status === 'I' &&   <span className="font-xxs font-semibold text-black w-full inline-block leading-3 relative ">
                              {item.rxf_sig} {item?.rxf_org_date &&  `${'Start date: ' + moment.utc(item?.rxf_org_date).format('MM/DD/YYYY')}`}  {item?.rxf_exp_date &&  `${'Exp date: ' + moment.utc(item?.rxf_exp_date).format('MM/DD/YYYY')}`}
                            </span>}
                            {item?.is_diabetic === 'T' &&  <span className="font-xxs font-semibold text-black w-full inline-block leading-3 relative ">
                              {item?.rxf_expanded_sig}
                            </span>}
                            {item?.status !== 'I' &&  <span className="font-xxs font-semibold text-black w-full inline-block leading-3 relative">
                              {item?.is_diabetic !== 'T' && item.frequency}   {item?.is_diabetic !== 'T' &&<span className="font-bold">Qty/Dose: {item?.dose_qty}</span>} {item?.rxf_org_date &&  `${'Start date: ' + moment.utc(item?.rxf_org_date).format('MM/DD/YYYY')}`}  {item?.rxf_exp_date &&  `${'Exp date: ' + moment.utc(item?.rxf_exp_date).format('MM/DD/YYYY')}`}  
                            </span>}
                           { <span className="font-xxs font-semibold  text-black w-full inline-block leading-3 relative bottom-1">
                           { item.last_admit_date && <span>Last administered: {item.last_admit_date} </span>} {item?.is_kop ==='T' && <span className="font-bold">Qty given: {item?.last_admit_qty}</span>}
                            </span>}
                            { <span className="font-xxs font-semibold  text-black w-full inline-block leading-3 relative bottom-3">
                           {item?.last_fil_date && item?.is_kop === 'T' && `${'Last filled: ' + moment.utc(item?.last_fil_date).format('MM/DD/YYYY')}`} 
                            </span>}
                          </div>
                          <div className="w-1/2 	m-auto">
                          {!(item?.monthly_drug_admin_limit  && item?.current_month_drug_admin_count >item?.monthly_drug_admin_limit) &&  (<div>
                         {item?.monthly_drug_admin_limit > 0 &&  <div> Administered this month : {item?.current_month_drug_admin_count}</div>}
                         
                        {item?.status !== 'I' &&  (<div>
                         {item?.is_kop === 'F' ? <div className=" h-fit flex text-center rounded  m-2 ">
                              <span
                                className={` py-2 px-4 ${user?.userRole === "EMAR_USER" ? 'mediSelfApproved' : 'mediApproved'}  text-sm  rounded-3xl border-inherit  mr-4  ${disableModalMedications ? 'cursor-not-allowed' : 'cursor-pointer'} ${((item?.status === 'A' || item?.status === 'P') && !disableModalMedications) ? 'bg-mediApproved borderSelected ' : 'bg-white border'} ${(item?.status === 'S' && !disableModalMedications) ? 'bg-mediSelfApproved borderSelected ' : 'bg-white border'}`}
                                onClick={(e) => {
                                  if(user?.userRole === "EMAR_USER"){
                                    handleMedication(item, i, "S", e.target)
                                  }else{
                                    handleMedication(item, i, "A", e.target)
                                  }
                                  
                                }}
                              >
                                Yes
                              </span>
                              <span
                                className={` py-2 px-4 rounded-3xl mediRejected text-sm border-inherit  mr-4  ${disableModalMedications ? 'cursor-not-allowed' : 'cursor-pointer'} ${(item?.status === 'N' && !disableModalMedications) ? 'bg-mediRejected borderSelected' : 'bg-white border'}`}
                                onClick={(e) => handleMedication(item, i, "N", e.target)}
                              >
                                No
                              </span>
                              <span
                                className={`py-2 px-4 mediRefused rounded-3xl text-sm border-inherit  mr-4  ${disableModalMedications ? 'cursor-not-allowed' : 'cursor-pointer'} ${((item?.status === 'R' ||item?.status === 'D') && !disableModalMedications) ? 'bg-mediRefused borderSelected' : 'bg-white border'}`}
                                onClick={(e) => handleMedication(item, i, "R", e.target)}
                              >
                                Refused
                              </span>
                            </div> : <div className={`h-fit flex text-center rounded  m-2  ${disableModalMedications ? 'cursor-not-allowed' : 'cursor-pointer'}`}>
                              {item.kop_date ? <span
                                className={` py-2 px-4 rounded-3xl  text-sm border-inherit  mr-4  bg-slate border`}
                              >

                                  {item.status === 'K' ?
                                      <>
                                        <span className="pr-16">Keep on person</span>
                                        <span className="pr-16"> {moment(item.kop_date).format("MM/DD/YYYY")}</span>
                                        <span>{item?.dose_taken_qty}</span>
                                      </>
                                      :
                                      <div>
                                      <div className="grid grid-cols-2 gap-2 text-left">
                                        <span>
                                          <span className="pr-16">Keep on person</span>
                                          <span className="pr-16"> {moment(item.kop_date).format("MM/DD/YYYY")}</span>
                                        </span>
                                        <input
                                          type="number"
                                          min={0}
                                          defaultValue={KOPInputValues[item.rxf_id]}
                                          onBlur={(e) => handleInputChange(e, i, item.rxf_id)}
                                          className={` border focus:outline-none h-11 rounded-2xl pl-2 font-normal w-full text-black text-sm`}
                                        />
                                        </div>
                                        {(item.koperror || (item.qty_dsp !== null  && item?.qty_dsp !== 0 && Number(item?.dose_taken_qty) > Number(item?.qty_dsp))) && (
                                      <p className="text-xs md:text-sm md:pt-1 text-hlred table error">
                                        You are administering more than the dose
                                      </p>
                                    )}
                                     {(Number(item?.dose_taken_qty) <= 0 ) && (
                                      <p className="text-xs md:text-sm md:pt-1 text-hlred table error">
                                         Please enter a number greater than  zero
                                      </p>
                                    )}
                          

                                      </div>
                                    }
                              </span> :
                                <span
                                  onClick={() => {
                                    if (!disableModalMedications) {
                                      const row = medications[i];
                                      row.kop_date = moment(date).format("MM/DD/YYYY");
                                      row.dose_taken_qty = KOPInputValues[item.rxf_id];
                                      setMedications([...medications]);
                                      setDisableModalReason(true);
                                      setModalReason("");
                                      doKOPQtyValidation(row?.fil_id,KOPInputValues[item.rxf_id], i); 
                                    }

                                  }}
                                  className={` py-2 px-4 rounded-3xl  text-sm border-inherit  mr-4    border`}
                                >
                                  <span className="pr-16">Keep on person</span>
                                </span>
                              }
                            </div>}</div>)}
                         </div>  ) }
                            {item?.status === "N" && (
                              <div className="w-full p-2">
                                <select
                                  name="reason"
                                  aria-label="Select Reason"
                                  onChange={(e) =>
                                    handleMedicationReason(
                                      item,
                                      i,
                                      e.target.value,
                                      "med_reason_id"
                                    )
                                  }
                                  value={item["med_reason_id"] || defaultRejectedReason}
                                  className="border w-1/2 focus:outline-none h-11 rounded-md pl-2 font-normal text-fogotpwsd_login text-sm"
                                >
                                  <option value="">Select Reason</option>
                                  {medReasonList
                                    ? medReasonList.map((item, i) => {
                                      return (
                                        <option
                                          key={item.id}
                                          value={item.id}
                                        >
                                          {item.reason}
                                        </option>
                                      );
                                    })
                                    : null}
                                </select>
                              </div>
                            )}
                            {(item?.status === "A" || item?.status === "S" || item?.status === "P") && (
                              <div className="w-full p-2">
                                <div>
                                  <input
                                    id="amtFilled"
                                    name="amtFilled"
                                    type="number"
                                    placeholder="Enter"
                                    defaultValue={item?.dose_taken_qty || item?.dose_qty}
                                    onBlur={(e) => {
                                      handleMedicationReason(
                                        item,
                                        i,
                                        Number(e.target.value),
                                        "dose_taken_qty"
                                      );
                                    }
                                    }
                                    className={` border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm`}
                                  />

                                </div>
                                {item?.status !== "P" && Number(item?.dose_taken_qty) > Number(item?.dose_qty) && (
                                  <p className="text-xs md:text-sm md:pt-1 text-hlred table">
                                   You are administering more than the dose
                                  </p>
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                        { item?.status === 'I' &&<div className="text-sm  px-3 pb-3 text-grey_color">* This order is not reviewed by the Pharmacist</div>}
                      </li>
                    );
                  })
                  : <div className="flex justify-center text-base">No records found</div>}
              </ul>
            </div>
            <div className="text-xs medicationSection bg-brown-100 rounded-xl p-2 w-1/2">
              <div className="flex w-full mb-4  bg-brown p-2 rounded-lg">
                <div className="w-1/2 font-semibold text-lg text-white">
                Medication In progress /Special Schedules
                </div>
                <div className="w-1/2 font-semibold text-lg text-white">
                  Administer as Single Dose
                  <span className="text-xs md:text-sm text-hlred ml-1">*</span>
                </div>
              </div>
              <ul className="max-h-80 mt-4 overflow-y-auto  ">
                {(activeOrders && activeOrders?.length > 0)
                  ? activeOrders.map((item, i) => {
                    return (
                      <li key={Math.random()} className="focus:scroll-auto  rounded-xl inline-block text-xs leading-6 text-menu_txt w-full mb-4 border-inherit rounded medicationList">
                        <div
                          className={`flex w-full rounded-xl text-black px-3 pt-2  ${(item?.status === "P")
                            ? "bg-mediApproved"
                            : (item?.status === "D")
                              ? "bg-mediRefused"
                              : "bg-lightbrown"
                            }`}
                        >
                          <div className="w-1/2 flex-column">
                            <div className="text-base	font-semibold text-black">
                              {item.drg_name} {item?.is_diabetic === 'T' && <span className="bg-slate text-xs	ml-2">Insulin</span>}{item?.is_hypertensive === 'T' && <span className="bg-slate text-xs ml-2	">Blood Pressure</span>}
                              {item?.is_prn === 'T' && <span className="bg-slate text-xs ml-2	">PRN</span>}
                              {item?.is_crush === 'T' && <span className="bg-orange text-xs ml-2	">CRUSH</span>}
                              {item?.is_involuntary === 'T' && <span className="bg-orderFourhr text-xs ml-2	">INVOLUNTARY</span>}
                            </div>
                            {item?.status === 'I' &&   <span className="font-xxs font-semibold text-black w-full inline-block leading-3 relative ">
                              {item.rxf_sig}  {item?.rxf_org_date &&  `${'Start date: ' + moment.utc(item?.rxf_org_date).format('MM/DD/YYYY')}`} {item?.rxf_exp_date &&  `${'Exp date: ' + moment.utc(item?.rxf_exp_date).format('MM/DD/YYYY')}`}
                            </span>}
                            {item?.is_diabetic === 'T' &&  <span className="font-xxs font-semibold text-black w-full inline-block leading-3 relative ">
                              {item?.rxf_expanded_sig}
                            </span>}
                            {item?.status !== 'I' &&  <span className="font-xxs font-semibold text-black w-full inline-block leading-3 relative  ">
                              {item?.is_diabetic !== 'T' && item.frequency}   {item?.is_diabetic !== 'T' &&<span className="font-bold">Qty/Dose: {item?.dose_qty}</span>}  {item?.rxf_org_date &&  `${'Start date: ' + moment.utc(item?.rxf_org_date).format('MM/DD/YYYY')}`} {item?.rxf_exp_date &&  `${'Exp date: ' + moment.utc(item?.rxf_exp_date).format('MM/DD/YYYY')}`} 
                            </span>}
                            { <span className="font-xxs font-semibold  text-black w-full inline-block leading-3 relative bottom-1">
                           { item.last_admit_date && <span>Last administered: {item.last_admit_date} </span>} {item?.is_kop === 'T' && <span className="font-bold">Qty given: {item?.last_admit_qty}</span>}
                            </span>}
                           
                          </div>
                       {item?.is_admistration_allowed === 'T' &&   <div className="w-1/2 	m-auto">
                        {!(item?.monthly_drug_admin_limit  && item?.current_month_drug_admin_count >item?.monthly_drug_admin_limit) &&  (<div>
                         {item?.monthly_drug_admin_limit > 0 &&  <div> Administered this month : {item?.current_month_drug_admin_count}</div>}
                         <div className=" h-fit flex text-center rounded  m-2 ">
                       
                              <span
                                className={` py-2 px-4 ${user?.userRole === "EMAR_USER" ? 'mediSelfApproved' : 'mediApproved'}  text-sm  rounded-3xl border-inherit  mr-4  ${disableModalMedications ? 'cursor-not-allowed' : 'cursor-pointer'} ${((item?.status === 'A' || item?.status === 'P') && !disableModalMedications) ? 'bg-mediApproved borderSelected ' : 'bg-white border'} ${(item?.status === 'S' && !disableModalMedications) ? 'bg-mediSelfApproved borderSelected ' : 'bg-white border'}`}
                                onClick={(e) => {
                                  if(user?.userRole === "EMAR_USER"){
                                    handleActiveOrders(item, i, "S", e.target)
                                  }else{
                                    handleActiveOrders(item, i, "P", e.target)
                                  }
                                  
                                }}
                              >
                                Yes
                              </span>
                       
                            </div> </div>)}
                            {(item?.status === "P") && (
                              <div className="w-full p-2">
                                <div>
                                  <input
                                    id="amtFilled"
                                    name="amtFilled"
                                    type="number"
                                    placeholder="Enter"
                                    defaultValue={item?.dose_taken_qty || item?.dose_qty}
                                    onBlur={(e) => {
                                      handleMedicationReasonForActiveOrders(
                                        item,
                                        i,
                                        Number(e.target.value),
                                        "dose_taken_qty"
                                      );
                                    }
                                    }
                                    className={` border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm`}
                                  />

                                </div>
                                {item?.status !== "P" && Number(item?.dose_taken_qty) > Number(item?.dose_qty) && (
                                  <p className="text-xs md:text-sm md:pt-1 text-hlred table">
                                   You are administering more than the dose
                                  </p>
                                )}
                              </div>
                            )}
                          </div>}
                        </div>
                      </li>
                    );
                  })
                  : <div className="flex justify-center text-base">No records found</div>}
              </ul>
            </div>
          </div>
          <div className="bg-white mt-3 rounded w-full">
            <div className="text-xs medicationSection bg-blue-100  rounded-xl p-2 w-full mr-2">
              <div className="flex w-full mb-4 bg-blue p-2 rounded-lg">
                <div className="w-full font-semibold text-lg text-white">
                 STAT / Single Dose Meds Given Today
                </div>
              </div>
              <ul className="max-h-80  mt-4 overflow-y-auto  ">
                {(activeStatMeds && activeStatMeds?.length >0)
                  ? activeStatMeds.map((item, i) => {
                    return (
                      <li key={Math.random()} className="focus:scroll-auto rounded-xl inline-block text-xs leading-6 text-menu_txt w-full mb-4 border-inherit medicationList relative">
                        <div className="absolute top-1 right-3 cursor-pointer"
                          onClick={() => {
                            handleDeleteMedsGivenToday(item?.id, item?.pat_id);
                          }}
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" viewBox="0 0 512 512">
                            <path
                              fill="#df2316"
                              d="M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"
                            />
                          </svg>
                        </div>                       
                       <div
                          className={`flex w-full rounded-xl ${(item?.status === "P"|| item?.status === "D") ? 'opacity-40 pointer-events-none' : ''} text-black px-3 pt-2  ${(item?.status === "P")
                            ? "bg-mediApproved"
                            : item?.status === "S"
                              ? "bg-mediSelfApproved"
                            : item?.status === "N"
                              ? "bg-mediRejected"
                              : (item?.status === "R" || item?.status === "D")
                                ? "bg-mediRefused"
                                  : ""
                            }`}
                        >
                          <div className="w-1/2 flex-column">
                            <div className="text-base	font-semibold text-black">
                              {item.drg_name} {item?.is_diabetic === 'T' && <span className="bg-slate text-xs	ml-2">Insulin</span>}{item?.is_hypertensive === 'T' && <span className="bg-slate text-xs ml-2	">Blood Pressure</span>}
                              {item?.is_prn === 'T' && <span className="bg-slate text-xs ml-2	">PRN</span>}
                              {item?.is_crush === 'T' && <span className="bg-orange text-xs ml-2	">CRUSH</span>}
                              {item?.is_involuntary === 'T' && <span className="bg-orderFourhr text-xs ml-2	">INVOLUNTARY</span>}
                            </div>
                            {item?.status === 'I' &&   <span className="font-xxs font-semibold text-black w-full inline-block leading-3 relative ">
                              {item.rxf_sig} {item?.rxf_org_date &&  `${'Start date: ' + moment.utc(item?.rxf_org_date).format('MM/DD/YYYY')}`}  {item?.rxf_exp_date &&  `${'Exp date: ' + moment.utc(item?.rxf_exp_date).format('MM/DD/YYYY')}`}
                            </span>}
                            {item?.is_diabetic === 'T' &&  <span className="font-xxs font-semibold text-black w-full inline-block leading-3 relative ">
                              {item?.rxf_expanded_sig}
                            </span>}
                            {item?.status !== 'I' &&  <span className="font-xxs font-semibold text-black w-full inline-block leading-3 relative">
                              {item?.is_diabetic !== 'T' && item.frequency}   {item?.is_diabetic !== 'T' &&<span className="font-bold">Qty/Dose: {item?.dose_taken_qty}</span>} {item?.rxf_org_date &&  `${'Start date: ' + moment.utc(item?.rxf_org_date).format('MM/DD/YYYY')}`}  {item?.rxf_exp_date &&  `${'Exp date: ' + moment.utc(item?.rxf_exp_date).format('MM/DD/YYYY')}`}  
                            </span>}
                            { <span className="font-xxs font-semibold  text-black w-full inline-block leading-3 relative bottom-1">
                           { item.last_admit_date && <span>Last administered: {item.last_admit_date} </span>} {item?.is_kop === 'T' && <span className="font-bold">Qty given: {item?.last_admit_qty}</span>}
                            </span>}
                           
                          </div>
                        </div>
                        { item?.status === 'I' &&<div className="text-sm  px-3 pb-3 text-grey_color">* This order is not reviewed by the Pharmacist</div>}
                      </li>
                    );
                  })
                  : <div className="flex justify-center text-base">No records found</div>}
              </ul>
            </div>
          </div>
          <div className="flex justify-between	ml-2">
            <div className="flex justify-start">
            </div>
          { !( moment(date).isAfter(new Date())) && <div className="flex justify-end">
              <select
                name="reason"
                aria-label="Select Reason"
                onChange={(e) => {
                  setModalReason(e.target.value);
                  setDisableModalMedications(true);
                }}
                value={modalReason}
                disabled={disableModalReason}
                className="border w-1/2 focus:outline-noneh-10 mr-4 rounded-md pl-2 mb-3 mt-4 font-normal text-fogotpwsd_login text-sm"
              >
                <option key="select" value="">
                  Select Reason
                </option>
                {reasonList
                  ? reasonList.map((item, i) => {
                    return (
                      <option key={item.id} value={item.id}>
                        {item.reason}
                      </option>
                    );
                  })
                  : null}
              </select>
              <button
                onClick={onCloseMedicationModal}
                type="button"
                className="rounded font-medium h-10 mr-4 text-white w-auto px-4 bg-grey bg-login_btn mb-3 mt-4 focus:outline-none"
              >
                Cancel
              </button>
              {endPassStatus && <button
                onClick={() => {
                  setTimeout(() => handleMedicationSubmit(), 0);
                }}
                type="button"
                disabled={loading}
                className={
                  loading
                    ? "opacity-50 cursor-not-allowed pointer-events-none mr-0.5 rounded font-medium h-10 text-white w-auto px-6 bg-secondary bg-login_btn mb-3 mt-4 focus:outline-none"
                    : "mr-0.5 rounded font-medium h-10 text-white w-auto px-6 bg-secondary bg-login_btn mb-3 mt-4 focus:outline-none"
                 }    
                >
                Submit
              </button>}

            </div>}
          </div>
          
        </div>
      </Modal>
      <div className="bg-white w-11/12 mx-auto mt-6 mb-4 rounded shadow-md ">
        <div className="tableHeader flex clearboth shadow-md py-8 pl-3">
          <div className="w-1/4 text-darkclr font-semibold leading-10 ">
            <span className="text-xl">DOT MEDPASS</span>
          </div>
          <div className="w-3/4 pr-3 text-right font-semibold ">
            <span className="inline-block mr-3 py-2 ">
              <div>
                <select
                  name="types"
                  aria-label="Select Type"
                  value={type}
                  onChange={(e) => setType(e.target.value)}
                  className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm"
                >
                  <option value="">Select Type</option>
                  {types
                    ? types?.map((item, i) => {
                      return (
                        <option key={i} value={item}>
                          {item}
                        </option>
                      );
                    })
                    : null}
                </select>
              </div>
            </span>
            <span className=" py-2">
              <input
                type="checkbox"
                className="cursor-pointer  mb-4 "
                name="completed"
                value={completed}
                defaultChecked={completed}
                disabled={loading}
                onClick={(e) => {
                  setCompleted(e.target.checked);
                }}
              />
              {"  "} Completed
            </span>
            <span className="inline-block mr-6 py-2 ">
              <div>
                <DatePicker
                  placeholderText="MM/DD/YYYY"
                  selected={date}
                  onChange={(date) => {
                    setDate(moment(date, "MM-DD-YYYY").toDate());
                  }}
                  className="border focus:outline-none h-11 bg-header_bg text-white rounded-md pl-2 font-normal   text-sm"
                />
              </div>
            </span>
            <span className="inline-block mr-3 py-2 ">
              <div>
                <div className="dropdown">
                  <button className="p-2 dropdownLabel w-32 text-ellipsis rounded text-left">{selectedTimeText?.length > 0 ? selectedTimeText?.join(', ') : "Select time"}</button>
                  <div className="dropdown-content ">
                    {passes
                      ? passes.map((pass, i) => {
                        return (
                          <div key={pass.id} className="float-left text-left	">
                            <input type="checkbox" name={pass.title} data-start={pass?.start_time} className="m-3" onChange={(e) => {
                              if (e.target.checked) {
                                if (selectedTime?.length > 0) {
                                  let passStartTime = passes?.find(ele => ele.id == selectedTime[0])?.start_time;
                                  let start = moment.utc(passStartTime).subtract(4, 'hours').subtract(1, 'minutes');
                                  let end = moment.utc(passStartTime).add(4, 'hours').add(1, 'minutes');
                                  let now = moment.utc(e.target.dataset.start);
                                  if (now.isAfter(start) && now.isBefore(end)) {
                                    setSelectedTime([...selectedTime, e.target.value]);
                                    setSelectedTimeText([...selectedTimeText, e.target.name]);
                                  } else {
                                    const { hide } = cogoToast.error(
                                      "Select appropriate medpasses",
                                      {
                                        hideAfter: 15,
                                        onClick: () => {
                                          hide();
                                        },
                                      }
                                    );

                                  }

                                } else {
                                  setSelectedTime([...selectedTime, e.target.value]);
                                  setSelectedTimeText([...selectedTimeText, e.target.name]);
                                }


                              } else {
                                let filters = selectedTime.filter(item => item !== e.target.value);
                                setSelectedTime(filters);
                                let filterText = selectedTimeText.filter(item => item !== e.target.name);
                                setSelectedTimeText(filterText);
                              }
                            }} value={pass.id}  disabled={loading} checked={selectedTime.includes(pass.id + "")}></input> {pass.title}</div>

                        );
                      })
                      : null}
                  </div>
                </div>
              </div>
            </span>
            <span className="inline-block mr-3 py-2">
              <div>
                <select
                  name="region"
                  aria-label="Select Region"
                  onChange={(e) => setRegion(e.target.value)}
                  value={region}
                  className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-36 text-fogotpwsd_login text-sm"
                >
                  <option value="">Select Region</option>
                  {regionsList
                    ? regionsList.map((region, i) => {
                      return (
                        <option key={i} value={region}>
                          {region}
                        </option>
                      );
                    })
                    : null}
                </select>
              </div>
            </span>
            <span className="relative ">
              <input
                type="search"
                id="patSearch"
                onChange={(event) => {
                  setSearch(event.target.value);
                  let searchValue = event.target.value;
                  searchValue = searchValue?.replace(/^0+/, '');
                  if (completed) {
                    let items = totalPatients.filter(
                      (item) =>
                        item.pat_name
                          .toLowerCase()
                          .includes(searchValue?.toLowerCase()) ||
                        item.pat_acct_nubmer
                          .toLowerCase()
                          .includes(searchValue?.toLowerCase())
                    );
                    items = items.filter(item => item?.is_medpass_completed === 'T');
                    setPatients(items);
                  } 
                }}
                placeholder=" Search"
                value={search}
                className="border rounded pl-2  h-11 mb-2 focus:outline-none focus:none  font-light align-bottom"
              />
              <img
                src="/img/search-2.svg"
                alt=""
                className="absolute w-4 h-4  right-5 bottom-0"
              ></img>
            </span>
          </div>
        </div>
        <div className="p-2 text-xs  w-full grid grid-cols-3 gap-y-4 gap-x-1">
          <div
            className={`inline-block customtop absolute   z-50 ${loading ? "show" : "hidden"
              }`}
          >
            <Loader
              type="Oval"
              color="#00BFFF"
              height={50}
              width={50}
              timeout={300000} //3 secs
            />
          </div>
          {patients?.length > 0
            ? patients?.map((item, i) => {
              return (
                <div key={item?.pat_id}
                  className={`grey  flex   rounded-3xl p-4 m-4  flex-auto cursor-pointer  ${item?.status === "A"
                    ? "bg-mediApproved"
                    : item?.status === "S"
                      ? "bg-mediSelfApproved"
                       : item?.status === "N"
                      ? "bg-mediRejected"
                      : item?.status === "R"
                        ? "bg-mediRefused"
                        : "bg-bodybgrnd"
                    }`}
                  onClick={(e) => {
                    const isMoreThan24Hours = moment().diff(date, 'hours') > 24;
                    if (item?.is_medpass_completed === 'T' && isMoreThan24Hours) {
                      handleNavigationToHistory(item);
                    } else if ((item?.is_medpass_completed !== 'T' && e.target.id !== "hold" && item?.is_hold !== 'T') || (item?.is_medpass_completed === 'T' && !isMoreThan24Hours)) {
                      setPatData(item);
                      getMedications(item.pat_id);
                    }

                  }}
                >
                  <div className="mr-4">
                    <img
                      className="rounded-full w-16 h-16"
                      alt=""
                      src={item?.profile_pic}
                    />
                  </div>
                  <div className="pt-1 w-full">
                    {item?.is_hold === 'T'  && <div onClick={(e) => {
                      setOnHoldOpenPopUp(true);
                      setPatArguments(item);
                    }}
                      id="hold"
                      className="bg-mediRejected text-xs inline"
                      title={` Start date : ${moment.utc(item.start_date).format('MM-DD-YYYY')} \n End date : ${moment.utc(item.end_date).format('MM-DD-YYYY')}`}>On Hold </div>}
                    {item?.is_hold !== 'T' && item?.is_medpass_completed !== 'T' && <div name="hold" className="flex justify-end	"><img
                      id="hold"
                      className="rounded-full w-4 h-4 flex-end "
                      alt=""
                      onClick={(e) => {
                        setOnHoldOpenPopUp(true);
                        setPatArguments(item);
                      }}
                      src={PAUSE}
                    /> </div>}
                    <div className="">
                      <span className="text-base font-semibold">
                        {item.pat_name}{" "}
                      </span>
                      <span className="text-xs font-semibold">
                        {item.pat_acct_nubmer}
                      </span>
                    </div>
                    <div className="text-xs font-semibold">
                      <span>{item.pat_gender} </span>.
                      <span> {item.pat_age} </span>.
                      <span>
                        {" "}
                        DOB : {moment.utc(item.pat_dob).format("MM/DD/YYYY")}
                      </span>
                    </div>
                  </div>
                </div>
              );
            })
            : null}
        </div>
        {nextUrl && <div
            className={`inline-block w-full flex justify-center ${loading ? "visible" : "invisible"}`}
          >
            <Loader
              type="ThreeDots"
              color="#00BFFF"
              height={50}
              width={50}
              timeout={300000} //3 secs
            />
          </div>}
        {patients?.length === 0 && (
          <div className="w-full flex justify-center">
            {" "}
            <img alt="" className="" src={NO_PATIENTS} />{" "}
          </div>
        )}

      </div>
    </>
  );
};

export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({}, dispatch);
    }
  )(MedpassAdministration)
);
